import React from 'react';
import { ButtonGroup, Button, Dropdown } from 'react-bootstrap';
import { getDatabase, ref, set as FirebaseSet, push as FirebasePush, remove as FirebaseRemove } from 'firebase/database';
import { Link } from "react-router-dom";

export default function PlanSelect(props) {
    var plans = props.plans
    var setCurrPlan = props.setCurrPlan;
    var username = props.username;

    var renderedPlans = "";
    if (plans !== []) {
        renderedPlans = plans.map((singlePlan, index) => {
            return <RenderPlan key={index} planId={singlePlan.key} plan={singlePlan} setCourse={props.setCourse} setCurrPlan={setCurrPlan} isLast={index===plans.length - 1} username={username}/>
        });
    }

    var expandStr = (props.expandPlan ? " expand" : "");

    const addPlan = () => {
        const db = getDatabase();
        var emptyAry = [];
        const emptyPlan = {
            "name": "New Plan",
            "plan": emptyAry
        }
        const userRef = ref(db, "users/" + username);
        FirebasePush(userRef, emptyPlan);
    }
    
    return (
    <div className={["p-2 align-self-center plan-container plan-masking plan-scroll" + expandStr]} style={{display: [props.style]}}>
        <div className="spacer"></div>
        <div>
            {renderedPlans}
            <div className="card card-spacer">
                <div className="card-body">
                <p className="card-title">Add New Plan</p>
                <p className="card-text">Click to add</p>
                <button className="btn btn-outline-primary" onClick={()=>{addPlan()}}>Add</button>
                </div>
            </div>

        </div>
    </div>
    );
}

function RenderPlan(props) {

    var plan = props.plan;
    var selectedCourse = plan["plan"] || null;
    var planName = plan["name"];
    var courseCodeStr = "";
    var ended = true;
    var id = props.planId;
    var planCopy = {name: planName + " - copy", "plan": selectedCourse};
    const [renameQuery, setRenameQuery] = React.useState("");
    const [renaming, setRenaming] = React.useState(false);

    const duplicatePlan = () => {
        const db = getDatabase();
        const userRef = ref(db, "users/" + props.username);
        FirebasePush(userRef, planCopy);
    }

    const removePlan = () => {
        const db = getDatabase();
        const userRef = ref(db, "users/" + props.username + "/" + id);
        FirebaseRemove(userRef);
    }

    const updateRename = (evt) => {
        setRenameQuery(evt.target.value);
    }

    const changePlanName = (evt) => {
        evt.preventDefault();
        if (renameQuery !== "") {
            const db = getDatabase();
            const userRef = ref(db, "users/" + props.username + "/" + id + "/name");
            FirebaseSet(userRef, renameQuery);
        }
        setRenameQuery("");
        setRenaming(false);
    }

    const renameForm = (
        <form className="d-flex rename-form mb-2" onSubmit={changePlanName}>
            <div>
                <label htmlFor='planNameInput' className="form-label card-rename-label">Set name to</label>
                <input type="text" className="form-control" placeholder="John Appleseed" id='planNameInput' aria-describedby="changePlanName" onChange={() => {updateRename()}}/>
            </div>

            <button type="submit"  className="btn btn-sm btn-outline-secondary rename-btn">
                <span className="material-icons done-icon">
                    done
                </span>
            </button>
        </form>
    );

    selectedCourse.forEach((singleCourse, index) => {
        var newClassCode = Object.keys(singleCourse)[0];
        if (courseCodeStr.length + newClassCode.length < 30) {
            courseCodeStr +=  newClassCode;
            if (index < selectedCourse.length - 1) {
                courseCodeStr += " · ";
            }
        }
        else if(ended) {
            courseCodeStr = courseCodeStr.substring(0, courseCodeStr.length - 3);
            courseCodeStr += "...";
            ended = false;
        }
    })
    
    courseCodeStr = courseCodeStr==="" ? "Go search and add some" : courseCodeStr;

    return (
        <div className="card">
            <div className="card-body">
                {renaming ? renameForm : (<p className="card-title">{planName}</p>)}
                <p className="card-text">{courseCodeStr}</p>

                <Dropdown as={ButtonGroup} drop={"end"}>
                    <Link to='/schedule' className="btn btn-primary" onClick={()=> {props.setCourse(selectedCourse); props.setCurrPlan(id)}}>View</Link>
                    <Dropdown.Toggle split id="dropdown-split-basic" />

                    <Dropdown.Menu>
                        <Dropdown.Item onClick={() => {setRenaming(true)}}>Rename</Dropdown.Item>
                        <Dropdown.Item onClick={() => {duplicatePlan()}}>Duplicate</Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item onClick={() => {removePlan()}}>Delete</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </div>
    )
}